(function(window, angular, undefined) {
  angular.module('formApp')
      .directive('sbDateSelectMobile', ['$filter', function ($filter) {
          var template = [
            '<input type="date" name="date" placeholder="DD/MM/YYYY" maxlength="10">'
          ];
          return {
            restrict: 'A',
            replace: true,
            template: template.join(''),
            require: 'ngModel',
            scope: {
              dateInfo: '@sbDateInfo',
              tooltip:  '@sbTooltip',
              selectId: '@sbSelectId',
              min:      '@min',
              max:      '@max',
              anzValidateConstraints: '=',
              coverdateData: '=',
              model: '=ngModel'
            },
            link: function(scope, elem, attrs, model) {

              model.$parsers.push(function(value) {
                return moment(value).format("YYYY-MM-DD");
              });

              var min, max;
          elem.bind("keyup", function() {

  
              });

           /*   if (scope.anzValidateConstraints) {
                scope.anzValidateConstraints.forEach(function(constraint) {
                    if (constraint.type === "custom") {
                        if (constraint.name === "mustBeWithin30Days") {
                            model.$validators.mustBeWithin30Days = function(modelValue) {
                                return model.$isEmpty(modelValue) || moment(modelValue).startOf('day').diff(moment().startOf('day'), 'days') < 30;
                            };
                        }
                        if (constraint.name === "mustBeAtLeastSixWeeksAtTimeOfCover") {
                            model.$validators.mustBeAtLeastSixWeeksAtTimeOfCover = function(modelValue) {
                                var coverStartDate = moment(scope.coverdateData);
                                var petDob = moment(modelValue);
                                return model.$isEmpty(modelValue) || coverStartDate.startOf('day').diff(petDob.startOf('day'),'weeks') >= 6;  // older than 5 full weeks = at least 6 weeks old
                            };
                            registerCoverDateWatch();
                        }
                        if (constraint.name === "cannotBeOlderThan") {
                            var unit = constraint.unit === 'yrs' ? 'years' : constraint.unit;
                            model.$validators.cannotBeOlderThan = function(modelValue) {
                                var coverStartDate = moment(scope.coverdateData).startOf('day');
                                return model.$isEmpty(modelValue) || coverStartDate.startOf('day').diff(moment(modelValue).startOf('day'), unit, true) < parseInt(constraint.value) + 1;
                            };
                            registerCoverDateWatch();
                        }
                    }
                });
              }
              function registerCoverDateWatch() {
                var unregister = scope.$watch('coverdateData', function(newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    unregister();
                    model.$validate();
                    registerCoverDateWatch();
                }, true);
              }*/
              model.$render = function() {
                if (!model.$viewValue) {
                  return;
                }
                var m = moment(model.$viewValue);
                scope.year = m.year();
                scope.month = m.month() + 1;
                scope.date = m.date();
              };
            }
          };
        }]);
 })(window, window.angular);